import React, { Component } from 'react';
import NowellonEditableFieldPropType from "../NowellonEditableField/NowellonEditableFieldPropType";
// import NowellonEditableField from "../NowellonEditableField";
import PropTypes from 'prop-types';
import shortid from "shortid";

class FaqSectionComponent extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      toogleActiveAcordionTab,
      getVal,
      FaqSection
    } = this.props;
    return (
        <div className="expert-tab-content expert-faq">
          <dl>
            {FaqSection.map(q => (
              <div key={shortid.generate()}>
                <dt className="expert-faq--question" onClick={toogleActiveAcordionTab}>{getVal(q.Question)}</dt>
                <dd className="expert-faq--answer" dangerouslySetInnerHTML={{ "__html": getVal(q.Answer) }} />
              </div>
            ))}
          </dl>
        </div>
    )
  }
}
FaqSectionComponent.propTypes = {
    toogleActiveAcordionTab: PropTypes.func.isRequired,
    getVal: PropTypes.func.isRequired,
    FaqSection: PropTypes.arrayOf(
      PropTypes.shape({
        Question: NowellonEditableFieldPropType.isRequired,
        Anwser: NowellonEditableFieldPropType.isRequired
      })
    ).isRequired
}
export default FaqSectionComponent;